// extracted by mini-css-extract-plugin
module.exports = {"card":"hero-card_card__SIZev"};